/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UploadSkillContentPayload,
  UploadSkillContentPayload$Outbound,
  UploadSkillContentPayload$outboundSchema,
} from "../components/uploadskillcontentpayload.js";

export type UploadSkillContentSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type UploadSkillContentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  uploadSkillContentPayload: UploadSkillContentPayload;
};

/** @internal */
export type UploadSkillContentSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const UploadSkillContentSecurity$outboundSchema: z.ZodMiniType<
  UploadSkillContentSecurity$Outbound,
  UploadSkillContentSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadSkillContentSecurityToJSON(
  uploadSkillContentSecurity: UploadSkillContentSecurity,
): string {
  return JSON.stringify(
    UploadSkillContentSecurity$outboundSchema.parse(uploadSkillContentSecurity),
  );
}

/** @internal */
export type UploadSkillContentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UploadSkillContentPayload: UploadSkillContentPayload$Outbound;
};

/** @internal */
export const UploadSkillContentRequest$outboundSchema: z.ZodMiniType<
  UploadSkillContentRequest$Outbound,
  UploadSkillContentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    uploadSkillContentPayload: UploadSkillContentPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      uploadSkillContentPayload: "UploadSkillContentPayload",
    });
  }),
);

export function uploadSkillContentRequestToJSON(
  uploadSkillContentRequest: UploadSkillContentRequest,
): string {
  return JSON.stringify(
    UploadSkillContentRequest$outboundSchema.parse(uploadSkillContentRequest),
  );
}
